module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Intimate-celebrations.42116fda.webp";